await import(/* webpackChunkName: "slidingMenu" */ 'Feature/Common/code/Scripts/SlidingMenu/slidingMenu');

window.am = window.am || {};

window.am.desktopLotteryNavigation = new function() {
  var that = this;

  this.closeTarget = null;
  this.currentActiveNavLink = null;

  this.init = function() {
    var navlinks = document.querySelectorAll('.lottery-mainnav__list a');
    that.currentActiveNavLink = document.querySelector(".lottery-mainnav__list a.active");

    if (that.currentActiveNavLink != null) {
      that.setUnderline(that.currentActiveNavLink);
    }

    if (navlinks.length == 0) {
      return;
    }

    var $mainNavLineHover = $(".sliding_menu[data-line-hover]");
    $(".sliding_menu[data-line-hover]").each(function(index) {
      var $items = $(this).find(".sliding_menu_link");

      window.am.slidingMenu.init($(this), $items);
    });

    navlinks.forEach(function(navlink) {
      navlink.addEventListener("click", function(e) {
        that.closeTarget = e.currentTarget;
        var currentTarget = e.currentTarget;
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (document.querySelector(".lottery-mainnav__overlay") == null) {
          document.querySelector("header").insertAdjacentHTML("beforeend", '<div class="lottery-mainnav__overlay"></div>');
        }

        setTimeout(function() {
          document.querySelector(".lottery-mainnav__overlay").style.height = document.querySelector("main").clientHeight + document.querySelector("footer").clientHeight + 27 + "px";
          document.querySelector(".lottery-mainnav__overlay").classList.add("lottery-mainnav__overlay--opened");
        }, 10);

        document.querySelector(".lottery-mainnav__subnavi-close").addEventListener("click", function() {
          that.closeOverlay();
        });

        document.querySelector(".lottery-mainnav__subnavi-close").addEventListener("keydown", function(event) {
          if (event.which == 9) { // tab
            that.closeTarget.focus();
          }
        });

        document.querySelector(".lottery-mainnav__overlay").addEventListener("click", function() {
          that.closeOverlay();
        });

        that.hideCol2();
        that.hideCol3();

        document.querySelector(".lottery-mainnav__subnavi").style.top = document.querySelector("#target_mainnav").clientHeight - 3 + "px";
        document.querySelector(".lottery-mainnav__overlay").style.top = document.querySelector("header .container").clientHeight + "px";

        var childList = currentTarget.parent().querySelector('[role="menu"]');
        document.querySelector(".lottery-mainnav__subnavi-col-1").innerHTML = childList.outerHTML;
        document.querySelector('.lottery-mainnav__subnavi-col-1 [role="menu"]').classList.remove("dropdown-menu");
        document.querySelector(".lottery-mainnav__subnavi").classList.add("lottery-mainnav__subnavi--opened");

        that.setSecondLevelEvents();
        that.clickCurrentActive();
        e.preventDefault();

        setTimeout(function() {
          var widthFactor = 1;
          that.setLevelColWidth(12);
          if (childList.querySelectorAll('.dropdown-item-thirdlevel').length) {
            widthFactor = 3;
            that.setLevelColWidth(4);
          } else if (childList.querySelectorAll('.dropdown-item-secondlevel').length) {
            widthFactor = 2;
            that.setLevelColWidth(6);
          }
          document.querySelector(".lottery-mainnav__subnavi").style.width = 406 * widthFactor + "px";
          that.setLevelHeight();

          document.querySelector(".lottery-mainnav__subnavi-col-1 a").focus();
          that.setFirstLevelActive(currentTarget);
          that.setUnderline(currentTarget);

          document.querySelector(".lottery-mainnav__subnavi-col-1 > ul > li:first-child").addEventListener("keydown", function(e) {
            if (e.shiftKey && e.which == 9) { // tab
              setTimeout(function() {
                that.closeTarget.focus();
              }, 10);
            }
          });
        }, 10);
      });
    });
  };

  this.closeOverlay = function() {
    document.querySelector(".lottery-mainnav__overlay").classList.remove("lottery-mainnav__overlay--opened");
    document.querySelector(".lottery-mainnav__subnavi").style.height = 0 + "px";
    document.querySelector(".lottery-mainnav__subnavi").style.width = 0 + "px";
    that.hideCol2();
    that.hideCol3();

    if (that.currentActiveNavLink == null) {
      that.hideUnderline();
      that.unsetFirstLevelActive();
    } else {
      that.setUnderline(that.currentActiveNavLink);
      that.setFirstLevelActive(that.currentActiveNavLink);
    }

    that.closeTarget.focus();
    setTimeout(function() {
      var overlay = document.querySelector(".lottery-mainnav__overlay");
      if (overlay) {
        overlay.remove();
      }
    }, 400);
  };

  this.setSecondLevelEvents = function() {
    var secondLevelItems = document.querySelectorAll('.lottery-mainnav__subnavi .dropdown-item-secondlevel');
    secondLevelItems.forEach(function(item) {
      item.addEventListener("click", function(e) {
        var childList = e.currentTarget.parentElement.nextElementSibling;
        that.hideCol2();
        that.setAnchorActive(e.currentTarget);
        document.querySelector(".lottery-mainnav__subnavi-col-2").innerHTML = childList.outerHTML;
        document.querySelector('.lottery-mainnav__subnavi-col-2 [role="menu"]').classList.remove("dropdown-menu");
        that.hideCol3();
        that.setLevelHeight();
        that.setThirdLevelEvents();
        e.preventDefault();
        setTimeout(function() {
          that.showCol2();
        }, 100);

        document.querySelector(".lottery-mainnav__subnavi-col-2 > ul > li:first-child").addEventListener("keydown", function(e) {
          if (e.shiftKey && e.which == 9) { // tab
            document.querySelector(".lottery-mainnav__subnavi-col-1 > ul > li > .active").focus();
            e.preventDefault();
          }
        });
      });
      item.addEventListener("keydown", function(e) {
        if (e.which == 13) { // enter
          setTimeout(function() {
            document.querySelector(".lottery-mainnav__subnavi-col-2 a").focus();
          }, 125);
        }
      });
    });
  };

  this.setThirdLevelEvents = function() {
    var secondLevelItems = document.querySelectorAll('.lottery-mainnav__subnavi .dropdown-item-thirdlevel');
    secondLevelItems.forEach(function(item) {
      item.addEventListener("click", function(e) {
        var childList = e.currentTarget.parentElement.nextElementSibling;
        that.hideCol3();
        that.setAnchorActive(e.currentTarget);
        document.querySelector(".lottery-mainnav__subnavi-col-3").innerHTML = childList.outerHTML;
        document.querySelector('.lottery-mainnav__subnavi-col-3 [role="menu"]').classList.remove("dropdown-menu");
        that.setLevelHeight();
        e.preventDefault();
        setTimeout(function() {
          that.showCol3();
        }, 100);

        document.querySelector(".lottery-mainnav__subnavi-col-3 > ul > li:first-child").addEventListener("keydown", function(e) {
          if (e.shiftKey && e.which == 9) { // tab
            document.querySelector(".lottery-mainnav__subnavi-col-2 > ul > li > .active").focus();
            e.preventDefault();
          }
        });
      });
      item.addEventListener("keydown", function(e) {
        if (e.which == 13) { // enter
          setTimeout(function() {
            document.querySelector(".lottery-mainnav__subnavi-col-3 a").focus();
          }, 125);
        }
      });
    });
  };

  this.setLevelColWidth = function(value) {
    document.querySelectorAll(".lottery-mainnav__subnavi-col").forEach(function(col) {
      col.classList.remove("col-12");
      col.classList.remove("col-6");
      col.classList.remove("col-4");
      col.classList.add("col-" + value);
    });
  };

  this.setLevelHeight = function() {
    setTimeout(function() {
      var col1Size = 32;
      var col2Size = 32;
      var col3Size = 32;

      document.querySelectorAll('.lottery-mainnav__subnavi-col-1 > [role="menu"]').forEach(function(anchor) {
        col1Size += anchor.clientHeight;
      });

      document.querySelectorAll('.lottery-mainnav__subnavi-col-2 > [role="menu"]').forEach(function(anchor) {
        col2Size += anchor.clientHeight;
      });

      document.querySelectorAll('.lottery-mainnav__subnavi-col-3 > [role="menu"]').forEach(function(anchor) {
        col3Size += anchor.clientHeight;
      });

      var sizeToSet = col1Size;
      if (sizeToSet < col2Size) {
        sizeToSet = col2Size;
      }
      if (sizeToSet < col3Size) {
        sizeToSet = col3Size;
      }

      document.querySelector(".lottery-mainnav__subnavi").style.height = sizeToSet + "px";
    }, 250);
  };

  this.showCol2 = function() {
    document.querySelector(".lottery-mainnav__subnavi-col-2").style.display = "block";
    setTimeout(function() {
      document.querySelector(".lottery-mainnav__subnavi-col-2").classList.add("lottery-mainnav__subnavi-col-2--visible");
    }, 10);
  };

  this.hideCol2 = function() {
    document.querySelector(".lottery-mainnav__subnavi-col-2").classList.remove("lottery-mainnav__subnavi-col-2--visible");
    setTimeout(function() {
      document.querySelector(".lottery-mainnav__subnavi-col-2").style.display = "none";
    }, 100);
  };

  this.showCol3 = function() {
    document.querySelector(".lottery-mainnav__subnavi-col-3").style.display = "block";
    setTimeout(function() {
      document.querySelector(".lottery-mainnav__subnavi-col-3").classList.add("lottery-mainnav__subnavi-col-3--visible");
    }, 50);
  };

  this.hideCol3 = function() {
    document.querySelector(".lottery-mainnav__subnavi-col-3").classList.remove("lottery-mainnav__subnavi-col-3--visible");
    setTimeout(function() {
      document.querySelector(".lottery-mainnav__subnavi-col-3").style.display = "none";
    }, 100);
  };

  this.clickCurrentActive = function() {
    var secondLevelActive = document.querySelector('.lottery-mainnav__subnavi .dropdown-item-secondlevel.active');
    setTimeout(function() {
      if (secondLevelActive != null) {
        secondLevelActive.click();

        setTimeout(function() {
          var thirdLevelActive = document.querySelector('.lottery-mainnav__subnavi .dropdown-item-thirdlevel.active');
          if (thirdLevelActive != null) {
            thirdLevelActive.click();
          }
        }, 150);
      }
    }, 150);
  };

  this.setAnchorActive = function(a) {
    a.parentElement.parentElement.children.forEach(function(li) {
      var menuitemAnchor = li.firstElementChild;
      menuitemAnchor.classList.remove("active");``;
      menuitemAnchor.setAttribute("aria-expanded", "false");
    });
    a.classList.add("active");
    a.setAttribute("aria-expanded", "true");
  };

  this.setUnderline = function(target) {
    var underline = document.querySelector(".lottery-mainnav_underline");
    if (underline) {
      var width = target.getBoundingClientRect().width;
      var height = 1;
      var left = target.getBoundingClientRect().left;
      var top = target.getBoundingClientRect().top + window.scrollY + target.getBoundingClientRect().height;

      underline.style.width = width + "px";
      underline.style.height = height + "px";
      underline.style.left = left + "px";
      underline.style.top = top + "px";
      underline.style.opacity = 1;
      underline.style.transform = "none";

      window.addEventListener("resize", function(event) {
        var width = target.getBoundingClientRect().width;
        var height = target.getBoundingClientRect().height;
        var left = target.getBoundingClientRect().left;
        var top = target.getBoundingClientRect().top + window.scrollY;

        underline.style.width = width + "px";
        underline.style.height = height + "px";
        underline.style.left = left + "px";
        underline.style.top = top + "px";
      });
    }
  };

  this.hideUnderline = function() {
    var underline = document.querySelector(".lottery-mainnav_underline");
    underline.style.opacity = 0;
    underline.style.transform = "translateX(-60px)";

    setTimeout(function() {
      underline.style.width = "";
      underline.style.height = "";
      underline.style.left = "";
      underline.style.top = "";
    }, 200);
  };

  this.setFirstLevelActive = function(target) {
    that.unsetFirstLevelActive();
    target.classList.add("active");
    target.setAttribute("aria-expanded", "true");
  };

  this.unsetFirstLevelActive = function() {
    var navlinks = document.querySelectorAll('.lottery-mainnav__list a');

    navlinks.forEach(function(link) {
      link.classList.remove("active");
      link.setAttribute("aria-expanded", "false");
    });
  };
};


window.addEventListener("load", () => {
    window.am.desktopLotteryNavigation.init();
});